export const GROUPS_LIST_CONSTANTS = {
  TOP_LEVEL_ID: 'groups-list-V2',
  MAX_CACHED_ITEMS: 200,
  ERROR_MESSAGE: 'Error fetching groups.',
  ERROR_TOAST_ID: 'fetch-groups-error_toast',
  EMPTY_STATE_MESSAGE: 'No groups available',
} as const;
